var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailReplyAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -2046.66667 2049 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M2048 1664v-1082q-29 23 -61 39.5t-67 28.5v815l-896 -449l-896 449v-953h704v-128h-832v1280h2048zM1024 1160l753 376h-1506zM1115 448l226 -227l-90 -90l-318 317l318 317l90 -90zM1499 512q50 0 110.5 2.5t121.5 -0.5t118 -14.5t101.5 -40t71 -77.5t26.5 -126 q0 -53 -20.5 -99.5t-55 -81t-81.5 -55t-99 -20.5v128q27 0 50 10t40.5 27.5t27.5 40.5t10 50t-10 50t-27.5 40.5t-40.5 27.5t-50 10h-293l162 -163l-90 -90l-317 317l317 317l90 -90z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReplyAll);
export default __webpack_public_path__ + "static/media/email-reply_all.a09250f4.svg";
export { ForwardRef as ReactComponent };